import { z } from 'zod';

export const AppointmentChannelSchema = z.enum([
  'videocall',
  'phonecall',
  'chat',
]);
export type AppointmentChannel = z.infer<typeof AppointmentChannelSchema>;

export const AppointmentChannelEnum = AppointmentChannelSchema.enum;
